const apiWorkflow = {
  'get-list': {
    method: 'post',
    url: '/client/admincp/workflow/list'
  },
  add: {
    method: 'post',
    url: '/client/admincp/workflow'
  },
  delete: {
    method: 'delete',
    url: '/client/admincp/workflow'
  },
  edit: {
    method: 'put',
    url: '/client/admincp/workflow/ID'
  }
}

export default {
  ...apiWorkflow
}
